import { getDeliveryStatusName } from 'components/ParcelComponent/utils';
import { getOfferStatus } from 'components/DealComponent/utils';
import moment from 'moment';
import { returnBaggageType } from '../../models/util';

export const COLUMN = (senderId?: number) => [
  {
    name: 'name',
    label: '',
    options: {
      customHeadRender: ({ index }) => (
        <th key={index} style={{ borderBottom: '0px solid rgba(224, 224, 224, 1)' }} />
      )
    }
  },
  {
    name: 'data',
    label: '',
    options: {
      customHeadRender: ({ index }) => (
        <th key={index} style={{ borderBottom: '0px solid rgba(224, 224, 224, 1)' }} />
      ),
      customBodyRender: (
        value: any,
        tableMeta: any,
        updateValue: (arg0: any) => void
      ): JSX.Element => (
        <>
          {tableMeta.rowIndex === 5 && senderId ?
            (
              <p onClick={() => {
                window.open(`/user/details/${senderId}`, '_blank');
              }}>
                {value}
              </p>
            ) : (
              <p>{value}</p>
            )
          }
        </>
      )
    }
  }
];
export const labels = [
  'Телефонный номер',
  'Фамилия',
  'Имя пользователя',
  'Отчество',
  'Дата рождения',
  'Эл. адрес',
  'Дата регистрации'
];
export const createParcelDetail = (
  detail: any,
  baggages: any,
  t: any
): { name: string; data: any }[] => {
  return [
    {
      name: t('title'),
      data: detail.parcelTitle
    },
    {
      name: t('date_of_creation'),
      data: moment(detail.createdOnTS).format('DD.MM.YYYY HH:mm').toString()
    },
    {
      name: t('address_from'),
      data: detail.addressFrom
    },
    {
      name: t('address_to'),
      data: detail.addressTo
    },
    {
      name: t('user_id'),
      data: detail.sender?.id
    },
    {
      name: t('fio_user'),
      data: `${detail?.sender?.firstName ?? ''} ${detail?.sender?.lastName ?? ''} ${detail?.sender?.middleName ?? ''}`
    },
    {
      name: t('number_user'),
      data: detail.sender.phone
    },
    {
      name: t('offer_date'),
      data: moment(detail.departureDateTimeTS).format('DD.MM.YYYY HH:mm').toString()
    },
    {
      name: t('sum'),
      data: `${detail.price ?? ''} ${detail.currency ?? ''}`
    },
    {
      name: t('type_baggage'),
      data: detail?.parcelTypes?.map(
        (item: string, index: number) =>
          returnBaggageType(item, baggages, index) +
          (detail.parcelTypes?.length - 1 === index ? '' : ', ')
      )
    },
    {
      name: t('description'),
      data: detail.parcelDescription
    },
    {
      name: t('grade'),
      data: detail.isRated ? t('yes') : t('no')
    },
    {
      name: t('status'),
      data: getDeliveryStatusName(detail.deliveryStatus, t)
    },
    {
      name: t('owner_price'),
      data: `${detail.priceForOwner ?? '-'} ${detail.priceForOwner ? detail.currency : ''}`
    },
    {
      name: t('shifters_price'),
      data: `${detail.priceForShifters ?? '-'} ${detail.priceForShifters ? detail.currency : ''}`
    },
    {
      name: t('recommended_price_status'),
      data: getPriceStatus(detail.recommendedPriceStatus, t)
    }
  ];
};
export const statuses = (t: any) => {
  return [
    {
      id: 0,
      title: t('pending')
    },
    {
      id: 1,
      title: t('delivered_status')
    },
    {
      id: 2,
      title: t('notDelivered_status')
    },
    {
      id: 3,
      title: t('received_status')
    },
    {
      id: 4,
      title: t('notReceived_status')
    }
  ];
};
export const getStatus = (text: string, t: any) => {
  switch (text) {
    case t('pending'):
      return 'Default';
    case t('delivered_status'):
      return 'Delivered';
    case t('notDelivered_status'):
      return 'NotDelivered';
    case t('received_status'):
      return 'Received';
    case t('notReceived_status'):
      return 'NotReceived';
  }
};
export const COLUMN_SHIFTER: any = (t: any): any => {
  return [
    {
      label: t('fio_carrier'),
      name: 'shifterFullName'
    },
    {
      label: t('id_travel'),
      name: 'id',
      options: {
        customBodyRender: (value, tableMeta, updateValue) => {
          return (
            <div style={{ cursor: 'pointer' }}>
              <p
                onClick={() => {
                  window.open(`/trip/details/${value}`, '_blank');
                }}>
                {value}
              </p>
            </div>
          );
        }
      }
    },
    {
      label: t('id_carrier'),
      name: 'shifterId',
      options: {
        customBodyRender: (value, tableMeta, updateValue) => {
          return (
            <div style={{ cursor: 'pointer' }}>
              <p
                onClick={() => {
                  window.open(`/user/details/${value}`, '_blank');
                }}>
                {value}
              </p>
            </div>
          );
        }
      }
    }
  ];
};
export const OPTIONS: any = (t: any) => {
  return {
    filter: false,
    responsive: 'vertical',
    draggableColumns: {
      enabled: true
    },
    print: false,
    download: false,
    search: false,
    sort: false,
    viewColumns: false,
    selectableRows: 'none',
    pagination: false,
    textLabels: {
      body: {
        noMatch: t('noMatch'),
        toolTip: t('sort'),
        columnHeaderTooltip: (column: any) => `${t('sort_by')} ${column.label}`
      },
      pagination: {
        next: t('next_page'),
        previous: t('previous'),
        rowsPerPage: t('rowsPerPage'),
        displayRows: t('a_from')
      },
      toolbar: {
        search: t('search'),
        downloadCsv: t('downloadCsv'),
        print: t('print'),
        viewColumns: t('viewColumn'),
        filterTable: t('filterTable')
      },
      filter: {
        all: t('all'),
        title: t('filters'),
        reset: t('reset')
      },
      viewColumns: {
        title: t('showColumns'),
        titleAria: t('show_hide_table_columns')
      },
      selectedRows: {
        text: t('row_selected'),
        delete: t('delete'),
        deleteAria: t('delete_area')
      }
    }
  };
};
export const COMLUMNOFFERS = (t?: any) => [
  {
    name: 'fullUserName',
    label: t('fio')
  },
  {
    name: 'description',
    label: t('description')
  },
  {
    name: 'offerStatus',
    label: t('offer_status')
  },
  {
    name: 'offerSum',
    label: t('sum')
  },
  {
    name: 'payment',
    label: t('payment')
  },
  {
    name: 'phoneNumber',
    label: t('number_phone')
  }
];
export const createOffers = (offers: any, t: any) => {
  return offers.map((offer: any) => {
    return {
      fullUserName: offer?.clientInfoModel?.fullUserName,
      description: offer.description,
      offerStatus: getOfferStatus(offer.status, t),
      offerSum: `${offer.price ?? ''} ${offer.currency ?? ''}`,
      payment:
        offer?.paymentStatus &&
        offer?.paymentStatus.includes('Paid')
          ? t('done')
          : t('not_done'),
      phoneNumber: offer.phone
    };
  });
};

const getPriceStatus = (status: string, t: any) => {
  switch (status) {
    case 'Proposed': return t('status_proposed');
    case 'Accepted': return t('status_accepted');
    case 'Declined': return t('status_declined');
    default: case 'None': return '-';
  }
}
